import React from 'react';
import { CalendarIcon, ClockIcon } from 'lucide-react';
import type { PeriodInfo, TimeframeType } from '../../types';
import { formatDateRange } from '../../utils/calculations';
interface PeriodSelectorProps {
  period: PeriodInfo;
  onPeriodChange: (type: TimeframeType) => void;
}
export function PeriodSelector({
  period,
  onPeriodChange
}: PeriodSelectorProps) {
  return <div className="flex items-center gap-4 flex-wrap" data-id="element-65">
      {/* Toggle */}
      <div className="inline-flex rounded-lg bg-gray-100 p-1" role="tablist" aria-label="Select timeframe" data-id="element-66">
        <button role="tab" aria-selected={period.type === 'weekly'} onClick={() => onPeriodChange('weekly')} className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${period.type === 'weekly' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-67">
          Weekly
        </button>
        <button role="tab" aria-selected={period.type === 'monthly'} onClick={() => onPeriodChange('monthly')} className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${period.type === 'monthly' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-68">
          Monthly
        </button>
      </div>

      {/* Period Info */}
      <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-69">
        <span className="inline-flex items-center gap-1.5" data-id="element-70">
          <CalendarIcon className="w-4 h-4" data-id="element-71" />
          {formatDateRange(period.startDate, period.endDate)}
        </span>
        <span className="inline-flex items-center gap-1.5" data-id="element-72">
          <ClockIcon className="w-4 h-4" data-id="element-73" />
          Day {period.daysElapsed} of {period.totalDays} ·{' '}
          {period.daysRemaining} days left
        </span>
      </div>
    </div>;
}